import { useEffect, useState } from "react";
import StaedteError from "./Error";

export default function CityDegrees(params) {

    const cityDegreesData = params.data;

    if ( isNaN( window.staedteFrontpageActiveDegreeIndex ) ) {
        window.staedteFrontpageActiveDegreeIndex = 0;
        window.staedteFrontpageDegreeRotating = true;
    }

    const[activeDegree, updateActiveDegree] = useState( window.staedteFrontpageActiveDegreeIndex );
    const[rotatingActive, setRotating] = useState( window.staedteFrontpageDegreeRotating );

    let errorOccured = undefined !== cityDegreesData.errors;

    useEffect(() => {

        if ( errorOccured ) {
            return;
        }

        let interval = window.setInterval(
            () => {
                
                if ( window.staedteFrontpageDegreeRotating ) {

                    window.staedteFrontpageActiveDegreeIndex = ( window.staedteFrontpageActiveDegreeIndex + 1 ) % 4;
                    updateActiveDegree( window.staedteFrontpageActiveDegreeIndex )

                }

            }
            , 3000
        );

        return () => clearInterval(interval);
    }, []);

    
    
    if ( errorOccured ) {
        // TODO: How to handle missing detail data?
        return(
            <>
                <StaedteError />
            </>
        );
    } else if ( undefined === cityDegreesData || 0 === cityDegreesData.length ) {
        return;
    }

    

    const event   = cityDegreesData.event;
    const imgURLs = 'https://www.bierbachelor.com/wp-content/plugins/Staedte/public/css/images/';
    
    let firstDegree = '';
    let secondDegree = '';
    let thirdDegree = window.staedteFrontendShortcodeData.i18n.doctor;
    let fourthDegree = window.staedteFrontendShortcodeData.i18n.habilitation;

    let firstDegreeImg  = 'BierBachelor_Zeugnis_BSC.jpg';
    let secondDegreeImg = 'BierBachelor_Zeugnis_MSC.jpg';
    let thirdDegreeImg  = 'BierBachelor_Zeugnis_DR.jpg';
    let fourthDegreeImg = 'BierBachelor_Zeugnis_Hab.jpg';

    switch( event ) {
        case 'BDPL':
            firstDegreeImg  = 'BDPL_Zeugnis_BSC.jpg';
            secondDegreeImg = 'BDPL_Zeugnis_MSC.jpg';
            thirdDegreeImg  = 'BDPL_Zeugnis_DR.jpg';
            fourthDegreeImg = 'BDPL_Zeugnis_Hab.jpg';
            firstDegree     = window.staedteFrontendShortcodeData.i18n.beerDiplom;
            secondDegree    = window.staedteFrontendShortcodeData.i18n.cumLaude;
            break;
        case 'CBSC':
            firstDegreeImg  = 'CocktailBachelor_Zeugnis_BSC.jpg';
            secondDegreeImg = 'CocktailBachelor_Zeugnis_MSC.jpg';
            thirdDegreeImg  = 'CocktailBachelor_Zeugnis_DR.jpg';
            fourthDegreeImg = 'CocktailBachelor_Zeugnis_Hab.jpg';
            firstDegree     = window.staedteFrontendShortcodeData.i18n.cocktailBachelor;
            secondDegree    = window.staedteFrontendShortcodeData.i18n.cocktailMaster;
            break;
        case 'BBSC':
        default:
            firstDegree  = window.staedteFrontendShortcodeData.i18n.beerBachelor;
            secondDegree = window.staedteFrontendShortcodeData.i18n.beerMaster;
    }


    let degreeData = [
        {
            img:    firstDegreeImg,
            step:   window.staedteFrontendShortcodeData.i18n.firstParticipation,
            name:   'bachelor',
            degree: firstDegree
        },
        {
            img:    secondDegreeImg,
            step:   window.staedteFrontendShortcodeData.i18n.secondParticipation,
            name:   'master',
            degree: secondDegree
        },
        {
            img:    thirdDegreeImg,
            step:   window.staedteFrontendShortcodeData.i18n.thirdParticipation,
            name:   'doktor',
            degree: thirdDegree
        },
        {
            img:    fourthDegreeImg,
            step:   window.staedteFrontendShortcodeData.i18n.fourthParticipation,
            name:   'habilitation',
            degree: fourthDegree
        }
    ]

    let rotateDegrees = function(index) {

        if ( ! window.staedteFrontpageDegreeRotating ) {
            window.staedteFrontpageDegreeRotating = true;
            setRotating( window.staedteFrontpageDegreeRotating );
        }

        window.staedteFrontpageActiveDegreeIndex = index;
        updateActiveDegree( window.staedteFrontpageActiveDegreeIndex );

    }

    let degreesJSX = [];
    let imgJSX     = [];
    degreeData.forEach(
        (degree, index) => {

            imgJSX.push( <div key={`img-${index}`} className={ ( ( window.staedteFrontpageActiveDegreeIndex === index ) ? '' : 'd-none' ) + ' h-100 d-flex' }>
                <img style={{maxHeight: "435px"}} className="m-auto img" id={degree.name} alt={degree.degree} src={`${imgURLs}${degree.img}`} />
            </div> );

            let currentDegreeStyle = {
                opacity: 0.5,
                borderLeft: "4px solid #666"
            };

            if ( rotatingActive && index <= activeDegree ) {
                currentDegreeStyle.opacity = 1;
                currentDegreeStyle.borderLeft = "4px solid #38b5cf"
            }

            degreesJSX.push(
                <div onClick={ev=>{rotateDegrees(index)}} style={currentDegreeStyle} key={`degree-${index}`} className="d-flex text-center h-100 pb-3 pb-lg-5 flex-column">
                    <h2 style={{fontSize: "18px", color: "#38b5cf"}} className="pb-0 mb-0">{degree.step}</h2>
                    <div><p className="fs-5 mb-0 fw-bold" style={{color: "#666"}} >{degree.degree}</p></div>
                </div>
            );

        }
    );

    return(
        <>
            <div>
                <div className="row mb-3">
                    <div className="col-6 col-lg-8">
                        <div className="mt-4 mb-4 m-3">
                            {
                                imgJSX
                            }
                        </div>
                    </div>
                    <div className="col-6 col-lg-4">
                        <div className="d-flex h-100 flex-column">
                            {degreesJSX}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}